import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface Miembro {
  nombre: string;
  primerNombre: string;
  cargo: string;
  padi: string;
  textoVisible: string;
  descripcionCompleta: string[];
}
const equipo: Miembro[] = [{
  nombre: 'Fernando Julián Alvarez',
  primerNombre: 'Fernando',
  cargo: 'Director de Buceo y Navegación',
  padi: 'Instructor PADI #342282',
  textoVisible: 'Seré tu primer punto de contacto durante todo el proceso. Te ayudaré a elegir la mejor opción para vos, resolveré tus dudas y coordinaré tu inscripción para que llegues al curso con toda la información necesaria.',
  descripcionCompleta: ['Seré tu primer punto de contacto durante todo el proceso.', 'Te ayudaré a elegir la modalidad que mejor se adapte a tus objetivos, responderé tus consultas, coordinaré tu inscripción y te acompañaré durante toda la organización previa al curso.', 'Mi objetivo es que llegues a tu primera clase con toda la información necesaria y la tranquilidad de saber exactamente qué esperar en cada etapa de tu formación.']
}, {
  nombre: 'Guido Oscar Montero',
  primerNombre: 'Guido',
  cargo: 'Instructor de buceo',
  padi: 'Instructor PADI #547262',
  textoVisible: 'Será quien te acompañe durante la formación teórica y práctica, guiándote paso a paso para que desarrolles confianza, comodidad y seguridad bajo el agua.',
  descripcionCompleta: ['Durante tu formación teórica y práctica estarás acompañado por un instructor profesional certificado que te guiará paso a paso durante todo el proceso de aprendizaje.', 'Su objetivo es ayudarte a desarrollar confianza, comodidad y seguridad bajo el agua, asegurando una experiencia de aprendizaje progresiva, profesional y divertida.', 'Desde tus primeras respiraciones bajo el agua hasta la obtención de tu certificación, recibirás acompañamiento constante para desarrollar habilidades sólidas y convertirte en un buzo seguro y confiado.']
}];
function TeamCard({
  m,
  index
}: {
  m: Miembro;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.12
  }} className="rounded-3xl border border-brand-primary/25 bg-brand-dark p-6 sm:p-7 flex flex-col" data-id="element-4">
      <h4 className="text-white font-heading font-bold text-xl sm:text-2xl tracking-tight" data-id="element-5">
        {m.nombre}
      </h4>
      <p className="text-white/70 text-sm mt-1" data-id="element-6">{m.cargo}</p>
      <span className="inline-flex items-center self-start rounded-full border border-brand-primary/40 bg-brand-primary/10 text-brand-primary text-xs font-bold tracking-widest uppercase px-3 py-1 mt-3" data-id="element-7">
        {m.padi}
      </span>

      <p className="text-white/75 text-sm sm:text-base leading-relaxed mt-5" data-id="element-8">
        {m.textoVisible}
      </p>

      <div className="mt-4 border-t border-brand-primary/15 pt-3" data-id="element-9">
        <button onClick={() => setOpen(o => !o)} aria-expanded={open} className="w-full flex items-center justify-between text-left text-brand-primary font-semibold text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/60 rounded-lg py-1" data-id="element-10">
          <span data-id="element-11">Conocer más sobre {m.primerNombre}</span>
          <ChevronDown size={18} className={`transition-transform duration-300 ${open ? 'rotate-180' : ''}`} data-id="element-12" />
        </button>

        <AnimatePresence initial={false} data-id="element-13">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-14">
              <div className="space-y-3 text-white/70 text-sm sm:text-base leading-relaxed pt-4" data-id="element-15">
                {m.descripcionCompleta.map((p, i) => <p key={i} data-id="element-16">{p}</p>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.div>;
}
export function Acompanamiento() {
  return <section className="py-24 px-6 bg-brand-background relative" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 max-w-2xl mx-auto" data-id="element-19">
          <h3 className="text-brand-primary font-heading font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight mb-4" data-id="element-20">
            Te acompañamos en cada etapa
          </h3>
          <p className="text-brand-details/90 text-lg font-light" data-id="element-21">
            Desde tu primera consulta hasta tu certificación, contarás con
            acompañamiento personalizado para que vivas una experiencia segura,
            organizada y profesional.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start" data-id="element-22">
          {equipo.map((m, index) => <TeamCard key={index} m={m} index={index} data-id="element-23" />)}
        </div>

        {/* Closing phrase + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="text-center mt-12 max-w-2xl mx-auto" data-id="element-24">
          <p className="text-white text-lg sm:text-xl font-light leading-relaxed mb-8" data-id="element-25">
            Miles de alumnos ya dieron su primera respiración bajo el agua junto
            a nuestro equipo. Ahora puede ser tu turno.
          </p>

          <button onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })} className="inline-block text-center w-full sm:w-auto bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] font-bold uppercase tracking-widest py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_-5px_rgba(0,184,217,0.4)]" data-id="element-26">
            Reservar mi vacante
          </button>

          <p className="text-white/60 text-sm mt-4" data-id="element-27">
            ¿Todavía tenés dudas? Escribinos y te ayudaremos a elegir la mejor
            opción para vos.
          </p>
        </motion.div>
      </div>
    </section>;
}